module.exports = __webpack_public_path__ + "static/img/logo.e5b990a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 541
// module chunks = 10